import React from "react";
export default class FormSubmit extends React.Component {
  render() {
    return (
      <div>
        <input
          type="submit"
          value={this.props.value}
          onClick={this.props.onSubmit}
          style={{
            border: "none",
            borderRadius: 5,
            height: 55,
            fontSize: 20,
            ...(this.props.styles || {}),
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Forms/Submit.js